import axios from "axios";
import React, { useEffect, useState } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import formatDateTime from "../../utils/DateTimeFormate";
import { Form } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import useFetch from "../../hooks/useFetch";
import request from "../../request/request";
import DeleteModal from "../../components/Modal/DeleteModal";
export default function SubscribedUser() {
  // const [allSubsUser, setAllSubsUser] = useState([]);
  const [filteredSubsUser, setFilteredSubsUser] = useState([]);
  const [modalState, setModalState] = useState({
    modalType: "",
    selectedId: null,
  });
  const { result: allSubsUser, setRefresh } = useFetch(() =>
    request.getAll("health-manager/getAllSubs")
  );

  useEffect(() => {
    setFilteredSubsUser(allSubsUser || []);
  }, [allSubsUser]);

  // useEffect(() => {
  //   (async function () {
  //     try {
  //       const { data } = await axios.get(
  //         `${process.env.REACT_APP_API_BASE_URL}/health-manager/getAllSubs`
  //       );
  //       console.log("data", data);
  //       setAllSubsUser(data?.data);
  //       setFilteredSubsUser(data?.data);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   })();
  // }, []);

  const handleDelete = async (id) => {
    try {
      await request.delete(`health-manager/delete-subs`, id, () => {
        setModalState({ modalType: "", selectedId: null });
        setRefresh((prev) => !prev);
      });
      // console.log("data", data);
    } catch (error) {
      console.log(error);
    }
  };

  // console.log("l", filteredSubsUser);

  const columns = [
    {
      key: "image",
      text: "Image",
      className: "image",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <>
            {record?.user_info?.image ? (
              <img
                className=" img-fluid"
                style={{ width: "50px" }}
                src={`${process.env.REACT_APP_UPLOAD_URL}/users/${record?.user_info?.image}`}
                // src={`${process.env.REACT_APP_UPLOAD_URL}/users/${record?.image}`}
                alt="Profile Pic"
              />
            ) : (
              <img
                className=" img-fluid"
                style={{ width: "50px" }}
                src="./dummy.jpg"
                alt="Profile Pic"
              />
            )}
          </>
        );
      },
    },
    {
      key: "registration_no",
      text: "Registration No",
      className: "registration_no",
      align: "left",
      sortable: true,
      cell: (record) => {
        return <>{record?.user_info?.registration_no}</>;
      },
    },
    {
      key: "name",
      text: "Name / Company",
      className: "info",
      align: "left",
      sortable: true,
      cell: (record) => {
        return (
          <>
            {record?.user_info?.f_name} {record?.user_info?.l_name}
          </>
        );
      },
    },
    {
      key: "mobile",
      text: "Mobile",
      className: "mobile",
      sortable: true,
      cell: (record) => <span>{record?.user_info?.mobile}</span>,
    },
    {
      key: "email",
      text: "Email",
      className: "email",
      sortable: true,
      cell: (record) => {
        return <>{record?.user_info?.email}</>;
      },
    },
    {
      key: "package",
      text: "Package",
      className: "info",
      align: "center",
      // sortable: true,
      cell: (data) => <span>{data?.package?.name}</span>,
    },
    {
      key: "package_cat",
      text: "Package Category",
      className: "info",
      align: "center",
      // sortable: true,
      cell: (data) => <span>{data?.package?.packageCat?.name}</span>,
    },
    {
      key: "purchase_date",
      text: "Subscription Date",
      className: "info",
      align: "center",
      sortable: true,
      cell: (data) => {
        return <span>{formatDateTime(data?.purchase_date)}</span>;
      },
    },
    {
      key: "expiry_date",
      text: "Expiry Date",
      className: "info",
      align: "center",
      sortable: true,
      cell: (data) => {
        return <span>{formatDateTime(data?.expiry_date)}</span>;
      },
    },
    {
      key: "action",
      text: "Action",
      className: "info",
      align: "center",
      sortable: true,
      cell: (data) => {
        return (
          <div className="d-flex justify-content-center gap-2">
            {/* <button type="button" className="btn btn-primary">
              <FaEdit />
            </button> */}
            <button
              type="button"
              className="btn btn-danger"
              onClick={() =>
                setModalState({
                  modalType: "delete",
                  selectedId: data?.id,
                })
              }
            >
              <FaTrash />
            </button>
          </div>
        );
      },
    },
  ];
  const config = {
    page_size: 10,
    show_filter: false,
    show_length_menu: true,
    show_pagination: true,
    pagination: "advance",
    length_menu: [10, 50, 100],
    button: {
      extra: true,
    },
  };

  const extraButtons = [
    {
      className: "bg-transparent border-0",

      title: "Search",
      children: [
        <Form.Group controlId="formBasicText">
          <Form.Control
            type={"search"}
            placeholder={"Search"}
            // value={value}
            onChange={(e) => handlerFilter(e.target.value)}
          />
        </Form.Group>,
      ],
      onClick: (event) => {
        // console.log(event);
      },
    },
  ];

  // search/filter functions

  const handlerFilter = (value) => {
    setFilteredSubsUser(
      allSubsUser.filter((item) => {
        return (
          item?.user_info?.registration_no
            ?.toString()
            ?.includes(value.toLowerCase()) ||
          item?.user_info?.f_name.toLowerCase().includes(value.toLowerCase()) ||
          item?.user_info?.mobile?.toString()?.includes(value.toLowerCase())
        );
      })
    );
  };

  // console.log("result", filteredSubsUser);

  return (
    <div className="card">
      <div className="card-body">
        <div className="border p-3 rounded">
          <div className="card-box">
            <h6 className="mb-0 text-uppercase">
              All Health Manager Subscribers List
            </h6>
            <div className="col">{/* Modal */}</div>
          </div>

          <hr />

          <div style={{ overflowX: "auto" }}>
            <ReactDatatable
              config={config}
              records={filteredSubsUser}
              columns={columns}
              extraButtons={extraButtons}
            />
          </div>
        </div>
      </div>

      {modalState.modalType === "delete" && (
        <DeleteModal
          isOpen={modalState.modalType === "delete"}
          onClose={() => setModalState({ modalType: "", selectedId: null })}
          handleDelete={() => handleDelete(modalState.selectedId)}
        />
      )}
    </div>
  );
}
